import * as yup from 'yup'

const CODE_REGEX = /^[A-Z0-9-]+$/

export const couponFormSchema = yup.object({
  code: yup
    .string()
    .required('Código do cupom é obrigatório')
    .min(
      4,
      'O código deve ter entre 4 e 20 caracteres (letras, números e hífen)'
    )
    .max(
      20,
      'O código deve ter entre 4 e 20 caracteres (letras, números e hífen)'
    )
    .test(
      'valid-code-format',
      'O código deve ter entre 4 e 20 caracteres (letras, números e hífen)',
      (value) => {
        if (!value) return false
        return CODE_REGEX.test(value.toUpperCase())
      }
    ),

  discount_type: yup
    .string()
    .oneOf(['percentage', 'fixed_value'], 'Tipo de desconto inválido')
    .required('Tipo de desconto é obrigatório'),

  discount_value: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required('O valor do desconto deve ser maior que zero')
    .moreThan(0, 'O valor do desconto deve ser maior que zero'),

  max_discount: yup
    .number()
    .transform((value) => (isNaN(value) ? null : value))
    .nullable()
    .when('discount_type', {
      is: 'percentage',
      then: (schema) => schema.optional().nullable(),
      otherwise: (schema) => schema.strip()
    }),

  max_usage: yup
    .number()
    .transform((value) => (isNaN(value) ? null : value))
    .nullable()
    .optional(),

  expires_at: yup.date().nullable().optional(),

  single_use_per_customer: yup.boolean().default(false)
})

export type CouponFormData = yup.InferType<typeof couponFormSchema>
